import UAParser from "ua-parser-js";
import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { $session } from "dot-framework";
import { $config, getAppDocumentTitle } from "@/tenant/config";
import store from "@/store";

/**
 * 디바이스 체크
 */
const isDesktopOrUnknownDevice = () => {
    const parser = new UAParser();
    const device = parser.getDevice();
    return typeof device === "object" && typeof device?.type === "undefined";
};

/**
 * 인증 없이 접근 가능한 route name
 */
const whiteList = [
    "appCheckBroker",
    "login",
    "login-callback",
    "support",
    "dotEasyHome",
    "stem",
    "explore"
];

/**
 * 멀티 테넌트 routes
 */
const routes = $config.getRoutes();

/**
 * Router 생성
 */
const router = createRouter({
    history:
        process.env.VUE_APP_IS_ELECTRON === "true"
            ? createWebHashHistory()
            : createWebHistory(),
    routes,
});

/**
 * 전역 라우터 가드
 */
router.beforeEach(async (to, from, next) => {
    /* 디바이스 체크 */
    if (
        !isDesktopOrUnknownDevice() &&
        to.name !== "appCheckBroker" &&
        from.name !== "appCheckBroker"
    ) {
        return next({ name: "appCheckBroker" });
    }

    /* name whitelist */
    if (whiteList.includes(to.name)) {
        return next();
    }

    /* meta.auth === false (root 포함) */
    const isNotNeedsAuth = to.matched.some(
        record => record.meta?.auth === false
    );

    if (store.getters["auth/isAuthenticated"] === null) {
        const ok = await $session.ensureLoggedIn();
        store.commit("auth/setAuthenticated", ok);
    }

    if (isNotNeedsAuth) {
        return next();
    }

    if (!store.getters["auth/isAuthenticated"]) {
        return next({
            name: "login",
            query: { redirect: to.fullPath },
        });
    }

    return next();
});

/**
 * 타이틀 설정
 */
router.afterEach((to) => {
    const base = getAppDocumentTitle();
    const path = to.path.split("/").filter(Boolean).join(", ");
    document.title =
        to.meta.title === undefined
            ? `${base} : ${path}`
            : to.meta.title;
});

export {
    router,
    routes
};
